import { loadQuery, type PreloadedQuery } from 'react-relay';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import { expVal } from '@atlassian/jira-feature-experiments';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import BACKLOG_FILTER_REFINEMENT_QUERY from '@atlassian/jira-relay/src/__generated__/backlogFilterRefinementQuery$parameters';
import type { backlogFilterRefinementQuery } from '@atlassian/jira-relay/src/__generated__/backlogFilterRefinementQuery.graphql';
import { createResource } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';

import { RESOURCE_TYPE_NEXTGEN_BACKLOG_FILTER_REFINEMENT } from '../../constants.tsx';

export const backlogFilterRefinementResource = resourceWithCondition2(
	() => expVal('filter_refinement_in_tmp_backlog', 'isEnabled', false),
	createResource<PreloadedQuery<backlogFilterRefinementQuery>>({
		type: RESOURCE_TYPE_NEXTGEN_BACKLOG_FILTER_REFINEMENT,
		getKey: () => 'backlog-filter-refinement-relay',
		getData: async ({ match, query }, { tenantContext }) => {
			const variables = {
				cloudId: tenantContext.cloudId,
				jql: query.jql ?? '',
				boardId: createAri({
					resourceOwner: 'jira-software',
					cloudId: tenantContext.cloudId,
					resourceType: 'board',
					resourceId: String(match.params.boardId),
				}),
				filterRefinementScope: {
					board: {
						boardId: Number(match.params.boardId),
					},
				},
			};

			const queryReference = loadQuery<backlogFilterRefinementQuery>(
				getRelayEnvironment(),
				BACKLOG_FILTER_REFINEMENT_QUERY,
				variables,
				{
					fetchPolicy: 'store-and-network',
				},
			);

			return queryReference;
		},
		isBrowserOnly: true,
		maxAge: 0,
	}),
);
